import { Type } from '@sinclair/typebox';
import { OwnerProfileSchema } from './owner-profile.js';
export const MakerTagSchema = Type.Union([
    Type.Literal('bundler'),
    Type.Literal('sniper'),
    Type.Literal('insider'),
    Type.Literal('fresh'),
    Type.Literal('mayhem'),
]);
export const MakerSchema = Type.Object({
    address: Type.String(),
    balanceInNative: Type.String(),
    balanceInToken: Type.String(),
    balanceInUsd: Type.String(),
    balanceInUsdPercentage: Type.String(),
    buys: Type.String(),
    sells: Type.String(),
    txes: Type.String(),
    buyVolumeInToken: Type.String(),
    sellVolumeInToken: Type.String(),
    buyVolumeInUsd: Type.String(),
    sellVolumeInUsd: Type.String(),
    volumeInUsd: Type.String(),
    /** Total PnL = rPnl + uPnl, cost-basis accounting (see @blade/finance-core). */
    pnl: Type.String(),
    /** Realized PnL = sellVolumeInUsd - sellVolumeInToken * entryPrice, where entryPrice = buyVolumeInUsd / buyVolumeInToken. */
    rPnl: Type.String(),
    /** Unrealized PnL = remaining holdings * (currentPrice - entryPrice). */
    uPnl: Type.String(),
    firstTxAt: Type.String(),
    lastTxAt: Type.String(),
    winRate30D: Type.Optional(Type.String()),
    pnl30D: Type.Optional(Type.String()),
    tags: Type.Optional(Type.Array(MakerTagSchema)),
    owner: Type.Optional(OwnerProfileSchema),
});
export const MakerWithRankSchema = Type.Composite([
    MakerSchema,
    Type.Object({
        rank: Type.Number(),
    }),
]);
//# sourceMappingURL=maker.js.map